export interface ChangelogEntry {
  body: string;
  /**
   * Local calendar day the entry shipped, as `YYYY-MM-DD`. The unseen-changelog notification
   * compares the newest entry's date with the last date this device opened the Changelog page for,
   * so keep one entry per day: a second entry on an already-seen day would not light the dot.
   */
  date: string;
}

export type ChangelogSortOrder = "newest" | "oldest";

/** Sort a copy so the authored newest-first list remains the notification's source of truth. */
export function sortChangelogEntries(
  entries: readonly ChangelogEntry[],
  order: ChangelogSortOrder,
): ChangelogEntry[] {
  return [...entries].sort((a, b) =>
    order === "oldest" ? a.date.localeCompare(b.date) : b.date.localeCompare(a.date),
  );
}

/** Newest first. Adding an entry with a later `date` lights the Changelog notification dot again. */
export const CHANGELOG_ENTRIES: readonly ChangelogEntry[] = [
  {
    body: "Welcome to Haniverse! Learn Chinese characters through memorable mnemonics, master pinyin and tones, and travel across the map of China in conversation missions.\n\nSpotted a bug, or have an idea or a question? Open the drawer in the top-right corner and tap the question mark to send feedback at any time.",
    date: "2026-11-01",
  },
];
